import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Globals } from "../../common/global";
import { ConfigApi } from "../..//config-api";
import { ApiCallingService } from "../../services/api-calling.service";

@Component({
  selector: "app-user-membership",
  templateUrl: "./user-membership.component.html",
  styleUrls: ["./user-membership.component.css"],
})
export class UserMembershipComponent implements OnInit {
  membershipList: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  totalCount: number = 0;
  loading: boolean = false;
  userDetails: any;
  detail: any = null;

  constructor(
    private router: Router,
    private apiCallingService: ApiCallingService,
    public globals: Globals
  ) {
    let data = localStorage.getItem("Auth-user");
    if (!data) {
      return;
    }
    try {
      this.userDetails = JSON.parse(data);
    } catch (error) {
      console.error(error);
    }
  }

  ngOnInit(): void {
    this.getMembershipList();
  }

  getMembershipList() {
    this.loading = true;
    const pageIndex = this.page > 0 ? this.page - 1 : 0;

    this.apiCallingService
      .callAPI(
        {},
        "GET",
        `${ConfigApi.URLS.MEMBERSHIP.USER_MEMBERSHIP_LIST}?page=${pageIndex}&limit=${this.pageSize}&operator_id=${this.userDetails?._id}`
      )
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.membershipList = res.data;
            this.totalCount = res.total;
            this.loading = false;
          }
        },
        (error) => {
          this.loading = false;
        }
      );
  }

  loadPage(page: number) {
    this.page = page;
    this.getMembershipList();
  }

  handleView(id: string) {
    this.router.navigate([`/user/user-membership/${id}`]);
  }
}
